module.exports = __webpack_public_path__ + "img/icon_shares.4c1c718a.svg";